import { Component, Input } from '@angular/core';
import { ZonaRoja } from '../../../services/integration/zonas-rojas/zonas-rojas.types';

@Component({
    selector: 'alerta-zona-roja',
    templateUrl: './alerta-zona-roja.component.html'
})
export class AlertaZonaRojaComponent {
    @Input() zonas: ZonaRoja[];
    @Input() etiqueta: string;
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/alerta-zona-roja/alerta-zona-roja.component.ts